module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window/window.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window/window.mtl
// module id = 504
// module chunks = 0